
import React from 'react';
import { AiOutlineCalendar, AiOutlineShoppingCart,AiOutlineMessage } from 'react-icons/ai';
import { FiShoppingBag, FiEdit, FiPieChart,  } from 'react-icons/fi';
import { IoAnalyticsOutline } from "react-icons/io5";
import { BiColorFill } from 'react-icons/bi';


import { BsPerson } from 'react-icons/bs';
import { BiBookAlt } from 'react-icons/bi';
import { IoMdContacts } from 'react-icons/io';
import { RiContactsLine,RiFileListLine } from 'react-icons/ri';




export   const LinkData = [
    { title: "Dashboard", icon:< IoAnalyticsOutline/>},
    { title: "Subjects", icon:< BiBookAlt/> },
    { title: "Invoice",  icon:< RiFileListLine/>, gap: true },
    { title: "Classes ",  icon:< FiEdit/> },
    { title: "Professors",  icon:< BsPerson/> },
    { title: "Messages",  icon:< AiOutlineMessage/> },
    { title: "Calendar ",  icon:< AiOutlineCalendar/>, gap: true },
    { title: "Setting",  icon:< IoMdContacts/> },
  ];